export const faqItems = [
  {
    question: '什么是"制服诱惑"？',
    answer: '制服诱惑是指职业制服所带来的独特视觉吸引力和时尚魅力。不同职业的制服承载着特定的文化符号和社会角色期待，这种符号化的服装能够唤起人们对专业、权威、温柔等特质的联想，从而产生独特的审美吸引力。从护士制服的纯净温柔到空姐制服的优雅专业，每一种制服都有其独特的美学密码。',
  },
  {
    question: '如何选择适合自己的制服风格？',
    answer: '选择制服风格需要考虑三个维度：个人气质、场合需求和文化偏好。温柔型气质适合护士、空姐等柔和风格的制服；干练型气质适合OL职业装或军装风格；青春活力型适合学生制服风格。建议从自己日常的穿搭偏好出发，选择与个人气质相契合的制服风格。',
  },
  {
    question: '制服cosplay需要注意哪些细节？',
    answer: '制服cosplay的成功关键在于细节还原度。首先，面料选择要尽量接近原版质感；其次，徽章、纽扣、领结等配饰的准确性至关重要；第三，妆容和发型要与角色匹配；最后，角色的姿态和表情也需要练习。记住，\"神还原\"比\"形似\"更重要。',
  },
  {
    question: '日常穿搭中如何融入制服元素？',
    answer: '日常穿搭中融入制服元素的关键是\"取其神而非取其形\"。可以选择制服中的某个标志性单品——如飞行员夹克、百褶裙或双排扣外套——搭配日常服装。避免全身制服造型，保持\"一件制胜\"的原则，让制服元素成为整体造型的亮点而非全部。',
  },
  {
    question: '如何保养制服类服装？',
    answer: '制服类服装通常采用较为正式的面料和剪裁，建议干洗为主。对于可水洗的制服，应使用中性洗涤剂冷水手洗或机洗轻柔模式，避免使用漂白剂。晾晒时避免阳光直射，最好使用宽肩衣架悬挂晾干。存放时使用防尘罩，定期熨烫保持挺括。',
  },
  {
    question: '影视剧中的制服造型对现实时尚有何影响？',
    answer: '影视作品中的制服造型往往能引发时尚潮流。例如《穿普拉达的女王》重新定义了职场女性的穿搭标准，《逃避可耻但有用》让家政制服变得时髦，《间谍过家家》引发了大量cosplay热潮。影视制服不仅是角色塑造的工具，更是时尚传播的重要媒介。',
  },
  {
    question: '不同国家的制服文化有何差异？',
    answer: '各国制服文化差异显著：日本制服文化最为丰富多元，从学生水手服到OL西装都形成了独特的美学体系；欧美制服更注重功能性和权威感；韩国制服偏向时尚化和青春感；中国制服则经历了从传统到现代的快速演变。这些差异反映了各国的社会文化和审美取向。',
  },
  {
    question: '制服cosplay和普通cosplay有什么区别？',
    answer: '制服cosplay专注于还原各类职业制服和影视制服造型，相比奇幻类和机甲类cosplay，制服的制作难度相对较低，更注重面料质感、剪裁和细节配饰的准确性。制服cosplay也更容易与日常穿搭产生联系，具有更强的实用性和参考价值。',
  },
];